import isArray from 'lodash/isArray';

import { DeviceTypeType, type AppData } from '../types/app_data';

import { isGarageFlow } from './garage';

/**
 * Helper file for 'StepTrustHeader' component.
 */
export interface StepTrustHeaderText {
  text: string;
  bold: boolean;
}

interface StepTrustHeaderTextListPerStep {
  [key: string]: StepTrustHeaderText[] | ((appData: AppData) => StepTrustHeaderText[]);
}

// List of trust-building texts to be displayed on each step of the funnel.
const headerText: StepTrustHeaderTextListPerStep = {
  // do not display app store rating on android
  welcome: (appData: AppData) =>
    appData.mobileOS === DeviceTypeType.Android
      ? []
      : [
          {
            text: 'Rated',
            bold: false,
          },
          {
            text: '4.7/5',
            bold: true,
          },
          {
            text: 'on the App Store',
            bold: false,
          },
        ],
  askInsured: (appData: AppData) =>
    // do not display app store rating on android
    appData.mobileOS === DeviceTypeType.Android
      ? []
      : [
          {
            text: 'Rated',
            bold: false,
          },
          {
            text: '4.7/5',
            bold: true,
          },
          {
            text: 'on the App Store',
            bold: false,
          },
        ],
  askClaims: [
    {
      text: 'Compare',
      bold: false,
    },
    {
      text: '45+ quotes',
      bold: true,
    },
    {
      text: 'including',
      bold: false,
    },
    {
      text: 'Progressive!',
      bold: true,
    },
  ],
  askViolations: [
    {
      text: 'On average, members',
      bold: false,
    },
    {
      text: 'save $600/year',
      bold: true,
    },
  ],
  name: [
    {
      text: 'Jerry protects your personal information.',
      bold: false,
    },
  ],
  phone: [
    {
      text: "Jerry won't spam you with unwanted calls",
      bold: false,
    },
  ],
  prefillphone: [
    {
      text: "Jerry won't spam you with unwanted calls",
      bold: false,
    },
  ],
  verify: [
    {
      text: 'Trusted by',
      bold: false,
    },
    {
      text: '691,213',
      bold: true,
    },
    {
      text: 'policy holders',
      bold: false,
    },
  ],
};

/**
 * Get proper step header text to be displayed for step container.
 * @param step
 * @param appData
 */
export const getStepTrustHeaderText = (step: string, appData: AppData): StepTrustHeaderText[] | undefined => {
  if (isGarageFlow(appData)) {
    return undefined;
  }
  const headerTextConfig = headerText[step];
  if (headerTextConfig) {
    return isArray(headerTextConfig) ? headerTextConfig : headerTextConfig(appData);
  }
  return undefined;
};
